import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getPhonecentersSysModel = (phonecentersSysModelId: number | undefined): Promise<IGetPhonecentersSysModel> => {
  return axiosDefaultApi.get(`/api/PhonecentersSysModels/GetPhonecentersSysModelViaID/${phonecentersSysModelId}`);
};

type QueryFnType = typeof getPhonecentersSysModel;

type UseGetPhonecentersSysModelOptions = {
  phonecentersSysModelId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPhonecentersSysModel = ({ phonecentersSysModelId , config }: UseGetPhonecentersSysModelOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getPhonecentersSysModel_${phonecentersSysModelId}`],
    queryFn: () => getPhonecentersSysModel(phonecentersSysModelId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Μοντέλου.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};